<template>
  <div id="printSet" class="search-set">
    <el-dialog
      ref="table"
      v-loading="loading"
      title="打印设置"
      :visible.sync="printSetDialod"
      width="750px"
      :before-close="printClose"
      center
    >
      <div class="contentBox" style="height: 420px; overflow-y: scroll">
        <!-- 要在页面展示的查询项 -->
        <el-form ref="changeData" class="demo-changeData" :model="changeData">
          <el-form-item label-width="75px" label="打印名称:" prop="setprintTitle">
            <el-input
              v-model="changeData.setprintTitle"
              :class="[
                changeData.setprintTitle && changeData.setprintTitle.length > 0
                  ? 'fillInput'
                  : '',
              ]"
            />
          </el-form-item>
          <el-form-item label-width="95px" label="打印单高度:" prop="tableHeight">
            <el-input
              v-model="changeData.setprintHeight"
              :class="[
                changeData.setprintHeight && changeData.setprintHeight.length > 0
                  ? 'fillInput'
                  : '',
              ]"
            />
          </el-form-item>
          <el-form-item label-width="75px" label="表格行距:" prop="tableHeight">
            <el-input
              v-model="changeData.setprintTableHeight"
              :class="[
                changeData.setprintTableHeight &&
                  changeData.setprintTableHeight.length > 0
                  ? 'fillInput'
                  : '',
              ]"
            />
          </el-form-item>
          <el-form-item label-width="109px" label="打印日期位置:" prop="tableHeight">
            <el-radio-group v-model="changeData.setTimePosition">
              <el-radio :label="'right'">右下角</el-radio>
              <el-radio :label="'left'">左下角</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="setcontent">
            <div class="set">
              <div style="font-size: 15px; padding-bottom: 5px">表单设置</div>
              <div class="set-item setTop" style="font-size: 14px">
                <div style="width: 120px">名称</div>
                <div style="width: 90px">宽度(%)</div>
                <div style="width: 60px; text-align: center">是否打印</div>
                <div style="width: 110px; text-align: center">显示位置</div>
              </div>
              <div class="setbottom">
                <div
                  v-for="(item, i) in changeData.setprintTopList"
                  :key="i"
                  draggable="true"
                  :class="[
                    'set-item',
                    item.title == isactive && item.prop == isactiverprop
                      ? 'activeBg'
                      : '',
                  ]"
                  @dragstart="handleDragStart($event, item, 1)"
                  @dragover.prevent="handleDragOver($event, item, 1)"
                  @dragenter="handleDragEnter($event, item, 1)"
                  @dragend="handleDragEnd($event, item, 1)"
                  @mouseover="into(i, 1)"
                  @mouseleave="outo(i, 1)"
                  @mousedown="onDown($event, item, 1)"
                  @onmousemove="onMove"
                >
                  <div style="width: 120px; font-size: 12px">
                    <input v-model="item.title" style="width: 100px" type="text">
                  </div>
                  <div style="width: 90px">
                    <input v-model="item.width" type="number">
                  </div>
                  <div style="width: 60px; text-align: center">
                    <el-checkbox v-model="item.isShow" />
                  </div>
                  <div style="width: 110px; text-align: end">
                    <el-radio-group v-model="item.showTop">
                      <el-radio :label="1">上</el-radio>
                      <el-radio :label="2">下</el-radio>
                    </el-radio-group>
                  </div>
                  <!-- {{ item.lable }} -->
                </div>
              </div>
            </div>
            <div class="set">
              <div style="font-size: 15px; padding-bottom: 5px">表格设置</div>
              <div class="set-item setTop" style="font-size: 14px">
                <div style="width: 120px">名称</div>
                <div style="width: 60px">是否打印</div>
              </div>
              <div class="setbottom">
                <div
                  v-for="(item, i) in changeData.setprinTtable"
                  :key="i"
                  draggable="true"
                  :class="['set-item', item.title == isactiveT ? 'activeBg' : '']"
                  @dragstart="handleDragStartT($event, item, 2)"
                  @dragover.prevent="handleDragOverT($event, item, 2)"
                  @dragenter="handleDragEnterT($event, item, 2)"
                  @dragend="handleDragEndT($event, item, 2)"
                  @mouseover="intoT(i, 2)"
                  @mouseleave="outoT(i, 2)"
                  @mousedown.stop="onDownT($event, item.title, 2)"
                  @onmousemove="onMove"
                >
                  <div style="width: 120px; font-size: 12px">
                    {{ item.title }}
                  </div>
                  <div style="width: 50px; text-align: center">
                    <el-checkbox v-model="item.isHave" />
                  </div>
                  <!-- {{ item.lable }} -->
                </div>
              </div>
            </div>
          </div>
          <el-form-item style="margin-top: 10px" label="上传Logo:" prop="tableHeight">
            <el-upload
              action="upload"
              :show-file-list="false"
              :http-request="handleUploadFile"
              multiple
            >
              <img
                v-if="changeData.setprintLogoImg"
                :src="changeData.setprintLogoImg"
                style="margin-top: 5px; height: auto; width: 170px"
              >
              <img
                v-if="!changeData.setprintLogoImg"
                src="../../assets/images/edit-upload.png"
                style="margin-top: 45px"
              >
              <p v-if="!changeData.setprintLogoImg" class="uploadText">上传lOGO</p>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="newButton" @click="confirmprintSet">确 定</el-button>
        <el-button class="new-buttondel" @click="printClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    printSetDialod: {
      type: Boolean
    },
    changeList: {
      type: Object,
      default: () => {}
    },
    pageName: {
      type: String,
      default: ''
    }
    // 已展示在页面的查询项数据
  },
  data() {
    return {
      changeData: {},
      isactive: '',
      isactiverprop: '',
      appectList: [],
      dragging: '',
      disx: 0,
      disy: 0,
      isactiveT: '',
      draggingT: '',
      disxT: 0,
      disyT: 0,
      loading: false
    }
  },
  computed: {
    //  showSearchData() {
    //   const searchData = [];
    //   //遍历所有查询项
    //   this.searchLists.forEach((data) => {
    //     let flag = false;
    //     for (let i = 0; i < this.showSearchData.length; i++) {
    //       if (this.showSearchData[i].lable == data.lable) {
    //         flag = true;
    //         break;
    //       }
    //     }
    //     if (!flag) {
    //       searchData.push(data);
    //     }
    //   });
    //   return searchData;
    // },
  },
  watch: {
    printSetDialod(v) {
      if (v) {
        this.changeData = JSON.parse(JSON.stringify(this.changeList))
      }
    },
    changeList(val) {
    }
  },
  created() {
    // this.$nextTick(() => {
    //     console.log(this.changeData.setprintTitle);
    // })
  },
  mounted() {},
  methods: {
    // 重写文件上传方法
    handleUploadFile(param) {
      const loading = this.$loading()
      param.headers = { 'Content-Type': 'application/json' }
      const formData = new FormData()
      formData.append('file', param.file)
      //   this.$fetch
      //     .post('/file/uploadImg', formData)
      //     .then((data) => {
      //       if (data.successful == true) {
      //         this.$set(
      //           this.changeData,
      //           'setprintLogoImg',
      //           this.$fetchbas.uploadBase + data.resultData.folderName
      //         )

    //         this.$message.success('上传成功')
    //         // console.log(this.changeData);
    //       } else {
    //         this.$message.warning('上传失败')
    //       }
    //       loading.close()
    //     })
    //     .catch((err) => {
    //       loading.close()
    //     })
    },
    // 鼠标按下事件
    onDown(e, item, type) {
      console.log(e)
      var rect = e.target.getBoundingClientRect()
      this.disx = rect.left
      this.disy = rect.top
      this.isactive = item.title
      this.isactiverprop = item.prop
    },
    // 鼠标移动事件
    onMove(e) {},
    // 拖拽事件
    datadragEnd(evt) {
      evt.preventDefault()
    },

    // 开始拖拽事件
    handleDragStart(e, item, type) {
      if (type == 1) {
        this.dragging = item
      } else {
        this.draggingT = item
      }
    },
    // 拖拽到另一个div中
    handleDragEnd(e, item, type) {
      this.dragging = null
    },
    // 首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item, type) {
      if (!this.dragging || this.dragging == null || this.dragging == '') {
        return
      }
      e.dataTransfer.effectAllowed = 'move' // 为需要移动的元素设置dragstart事件
      if (item.title === this.dragging.title) {
        return
      }
      const newItems = [...this.changeData.setprintTopList]
      const src = newItems.indexOf(this.dragging)
      const dst = newItems.indexOf(item)
      newItems.splice(dst, 0, ...newItems.splice(src, 1))
      this.changeData.setprintTopList = newItems
    },

    // 鼠标移入事件
    into(i, type) {
      if (type == 1) {
        this.changeData.setprintTopList.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", true);
          }
        })
      } else {
        this.changeData.setprinTtable.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", false);
          }
        })
      }
    },
    // 鼠标移出事件
    outo(i, type) {
      if (type == 1) {
        this.changeData.setprintTopList.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", false);
          }
        })
      } else {
        this.changeData.setprinTtable.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", false);
          }
        })
      }
    },

    // 鼠标按下事件
    onDownT(e, title, type) {
      var rect = e.target.getBoundingClientRect()
      this.disxT = rect.left
      this.disyT = rect.top
      this.isactiveT = title
    },
    rowClick(item) {
      this.$set(item, 'isHave', !item.isHave)
    },
    // 鼠标移动事件
    onMoveT(e) {},
    // 拖拽事件
    datadragEndT(evt) {
      evt.preventDefault()
    },

    // 开始拖拽事件
    handleDragStartT(e, item, type) {
      this.draggingT = item
    },
    // 拖拽到另一个div中
    handleDragEndT(e, item, type) {
      this.draggingT = null
    },
    // 首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOverT(e) {
      e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnterT(e, item, type) {
      e.dataTransfer.effectAllowed = 'move' // 为需要移动的元素设置dragstart事件
      if (item.title === this.draggingT.title) {
        return
      }
      const newItems = [...this.changeData.setprinTtable]
      const src = newItems.indexOf(this.draggingT)
      const dst = newItems.indexOf(item)
      newItems.splice(dst, 0, ...newItems.splice(src, 1))
      this.changeData.setprinTtable = newItems
    },

    // 鼠标移入事件
    intoT(i, type) {
      if (type == 1) {
        this.changeData.setprintTopList.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", true);
          }
        })
      } else {
        this.changeData.setprinTtable.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", false);
          }
        })
      }
    },
    // 鼠标移出事件
    outoT(i, type) {
      if (type == 1) {
        this.changeData.setprintTopList.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", false);
          }
        })
      } else {
        this.changeData.setprinTtable.forEach((item, index) => {
          if (index === i) {
            // this.$set(item, "show", false);
          }
        })
      }
    },

    // 点击取消事件
    printClose() {
      this.$emit('printClose', false)
      this.changeData = {}
    },

    // 点击确认事件
    confirmprintSet() {
      const ishave = this.isfilter(
        JSON.parse(JSON.stringify(this.changeData.setprintTopList)),
        'title'
      )
      if (ishave) {
        this.$message.warning("表单名称'" + ishave + "'重复,请重新修改")
        return
      }

    //   var param = new URLSearchParams()
    //   this.loading = true
    //   param.append('params', JSON.stringify(this.changeData))
    //   param.append('menuPageName', this.pageName)
    //   this.$fetch
    //     .post('/system/company/addPrintTemplate', param)
    //     .then((data) => {
    //       this.$emit('printOpen')
    //       this.loading = false
    //       this.changeData = {}
    //       this.isactive = ''
    //       this.isactiveT = ''
    //     })
    //     .catch((err) => {
    //       this.loading = false
    //       this.$message.warning(err.msg)
    //     })
    }
  }
}
</script>

<style scoped lang="scss">
.activeBg {
  color: #fff;
  background: #ff989e;
}
.el-dialog__header {
  background: #EC212D;
  color: #ffffff;
  padding: 15px;
}
.el-dialog__title {
  color: #ffffff;
}
.el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
  color: #ffffff;
}
.hide-item {
  display: none !important;
}
.newButton,
.new-buttondel {
  border: 1px solid #EC212D;
  font-size: 16px;
  color: #ffffff;
  box-sizing: border-box;
  width: 135px;
  height: 36px;
  background: #EC212D;
  padding: 5px 0;
}
.new-buttondel {
  background: #ffffff;
  color: #EC212D;
}
.el-dialog--center .el-dialog__body {
  padding: 10px 25px 15px;
}
// 查询项
.set {
  .setbottom {
    height: 300px;
    overflow-y: scroll;
    border: 1px solid #EC212D;

    border-top: 0;
    box-sizing: border-box;
  }
  .setTop {
    border: 1px solid #EC212D;

    background: #fde9ea;
    padding: 0 10px 20px 10px;
    margin-bottom: 0 !important;
    box-sizing: border-box;
  }
  .set-item {
    padding: 7px 10px;
    display: flex;
    // height: 30px;
    // line-height: 30px;
    position: relative;
    cursor: pointer; //小手样式
    -webkit-user-select: none; //不允许选中
    user-select: none; //不允许选中
    align-items: center;

    input {
      width: 50px;
      height: 23px;
      padding: 0 5px;
    }
    div {
    }
  }
}
// 展示项
.show {
  box-sizing: border-box;
  width: 92%;
  border: 2px solid #eeeeee;
  display: flex;
  justify-content: start;
  padding-bottom: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
  .show-item {
    box-sizing: border-box;
    text-align: center;
    margin-left: 20px;
    margin-top: 10px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #EC212D;
    color: #EC212D;
    cursor: pointer; //小手样式
    -webkit-user-select: none; //不允许选中
    user-select: none; //不允许选中
  }
}
.contentBox {
  padding: 0 10px;
}

// .contentBox ::-webkit-scrollbar {
//   display: none;
// }
.setbottom::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 6px; */
}
.setbottom::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 20px;
  background-color: #EC212D;
}
.setbottom::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: #fde9ea;
}
.setcontent {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top:10px ;
}
 .el-input__inner {
  width: 140px;
  height: 28px;
  border: 1px solid #d2d2d2;
  border-radius: 0;
  font-size: 12px;
}
.el-form-item__label {
  font-size: 12px;
  padding: 0 5px 0 0;
}
.el-form-item--small.el-form-item{
  margin-bottom: 8px;
}
.demo-changeData {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  font-size: 12px;
}
// 一个文件生效，另一个文件不生效

.el-radio__label{
  font-size: 12px;
  padding-left:2px;
}
.el-radio{
  margin-right:15px;
  // margin-left:10px
}
</style>
<style lang='scss'>
#printSet {
    .el-upload--text {
        background-color: #fff !important;
        border: 1px dashed #d9d9d9 !important;
        border-radius: 6px !important;
        box-sizing: border-box !important;
        width: 180px !important;
        height: 180px !important;
        text-align: center !important;
        cursor: pointer !important;
        position: relative !important;
        overflow: hidden !important;
    }
}
</style>
